import { useState } from "react";

/**
 * Hook encapsulating bulk-action UI state for CompanyDetails.
 *
 * @param {Object} opts
 * @param {Function} opts.getProjectsForCompany - returns project list for the company
 * @returns bulk-action state + handlers
 */
export function useBulkActions({ getProjectsForCompany } = {}) {
  const [selectedUsers, setSelectedUsers] = useState(new Set());
  const [openBulkAction, setOpenBulkAction] = useState(false);
  const [bulkActionType, setBulkActionType] = useState(null);
  const [displayProjects, setDisplayProjects] = useState([]);
  const [selectedProjectIds, setSelectedProjectIds] = useState(new Set());
  const [previewOpen, setPreviewOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [showWhitelistModal, setShowWhitelistModal] = useState(false);
  const [showUserStatusModal, setShowUserStatusModal] = useState(false);
  const [showProjectAccessModal, setShowProjectAccessModal] = useState(false);

  const handlePreviewOpen = () => setPreviewOpen(true);
  const handlePreviewClose = () => setPreviewOpen(false);

  const handleBulkAction = (type, companyIdNum) => {
    const selectedUserIds = Array.from(selectedUsers || []);
    if (selectedUserIds.length === 0) return;

    setBulkActionType(type);

    if (type === "whitelist" || type === "unwhitelist") {
      setShowWhitelistModal(true);
      return;
    }
    if (type === "user_status") {
      setShowUserStatusModal(true);
      return;
    }
    if (type === "project_access") {
      setShowProjectAccessModal(true);
      return;
    }
    if ((type === "add" || type === "remove") && getProjectsForCompany) {
      setDisplayProjects(getProjectsForCompany(companyIdNum));
    }

    setSelectedProjectIds(new Set());
    setOpenBulkAction(true);
  };

  const handleCloseBulkAction = () => {
    setOpenBulkAction(false);
    setSelectedProjectIds(new Set());
    setDisplayProjects([]);
  };

  const resetBulkState = () => {
    setSubmitting(false);
    setOpenBulkAction(false);
    setSelectedUsers(new Set());
    setSelectedProjectIds(new Set());
    setDisplayProjects([]);
  };

  const openProjectPicker = (type, companyIdNum) => {
    setBulkActionType(type);
    if (getProjectsForCompany) {
      setDisplayProjects(getProjectsForCompany(companyIdNum));
    }
    setSelectedProjectIds(new Set());
    setShowProjectAccessModal(false);
    setOpenBulkAction(true);
  };

  return {
    selectedUsers,
    setSelectedUsers,
    openBulkAction,
    setOpenBulkAction,
    bulkActionType,
    setBulkActionType,
    displayProjects,
    setDisplayProjects,
    selectedProjectIds,
    setSelectedProjectIds,
    previewOpen,
    handlePreviewOpen,
    handlePreviewClose,
    submitting,
    setSubmitting,
    showWhitelistModal,
    setShowWhitelistModal,
    showUserStatusModal,
    setShowUserStatusModal,
    showProjectAccessModal,
    setShowProjectAccessModal,
    handleBulkAction,
    handleCloseBulkAction,
    resetBulkState,
    openProjectPicker,
  };
}
